export default __webpack_public_path__ + "static/media/anafranil.798e9f1c.jpg";